import React from "react";
import { Form, ListGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import UserPhoto from "../user-photo/user-photo";
import "./group-select-member.scss";
import PropTypes from "prop-types";

const GroupSelectMemberNew = ({ user, data, disabled, selectedMember }) => {
  const cutString = (str) => {
    if (str.length > 35) {
      str = str.substring(0, 34);
      str = str + "...";
    }
    return str;
  };

  return (
    <div className="group-member-select">
      {
        <ListGroup.Item key={user.Id} className="member">
          <UserPhoto
            className="profile-picture small"
            key={JSON.stringify(user)}
            photo={null}
            name={user.Name}
            owner={user.Id === data.CreatorUserID}
          ></UserPhoto>
          <OverlayTrigger
            placement={"right"}
            delay={{ show: 150, hide: 150 }}
            overlay={
              <Tooltip id="button-tooltip">
                {user.Name + "(" + user.Email + ") - " + user.CompanyName}
              </Tooltip>
            }
          >
            <div className="user-title">
              {user.Active ? (
                <div className="userinfo">
                  {cutString(
                    user.Name + "(" + user.Email + ") - " + user.CompanyName
                  )}
                </div>
              ) : (
                <div className="userinfo inactive">
                  {cutString(
                    user.Name + "(" + user.Email + ") - " + user.CompanyId
                  )}
                </div>
              )}
            </div>
          </OverlayTrigger>
          <Form.Check
            disabled={disabled}
            onChange={(e) => selectedMember(e, user.Id)}
            className="select-user-checkbox remember-me"
            type={"checkbox"}
            checked={
              (data.Members ?? []).find((member) => member.Id === user.Id) !==
              undefined
            }
          ></Form.Check>
        </ListGroup.Item>
      }
    </div>
  );
};

GroupSelectMemberNew.propTypes = {
  user: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  selectedMember: PropTypes.func.isRequired,
};
export default GroupSelectMemberNew;
